module.exports = __webpack_public_path__ + "1f7e597ec6e88c43414c96dd8cd9ca7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/news/img1.jpg
// module id = 381
// module chunks = 0